import { GroupsQueryDocument } from "@pathwright/graphql-client/src/generated"

export default GroupsQueryDocument
